export default {"src":"/_next/static/media/assistant-handyman-with-small-text-box.520eee7b.svg","height":329,"width":338};